import type {SRSState} from "@/shared/types";

export const DEFAULT_SRS_STATE: SRSState = {
  ease: 250,
  intervalDays: 0,
  dueAt: new Date().toISOString(),
  repetition: 0,
};

export interface BatchRow {
  id: string;
  expression: string;
  field1: string;
  field2: string;
  meaning: string;
  auxiliary: string;
}
